import * as z from 'zod';

import { paginatedResponseSchema } from '@/_schemas/generic/paginated-response';
import { statusQuerySchema } from '@/_schemas/status-input';

import { manufacturerQueryLinkerSchema } from './manufacturer-query-linker-schema';

export const manufacturerQuerySchema = z.object({
  ...manufacturerQueryLinkerSchema.shape,
  status: statusQuerySchema,
  products_count: z.number().nullish(),
});

export type ManufacturerQuerySchema = z.infer<typeof manufacturerQuerySchema>;

export const manufacturerQueryAllSchema = paginatedResponseSchema(manufacturerQuerySchema);

export type ManufacturerQueryAllSchema = z.infer<typeof manufacturerQueryAllSchema>;
